import React from 'react';
import {Box, Typography, Chip} from '@mui/material';
import PropTypes from 'prop-types';

const MessageAttachments = ({attachments, conversationId, messageId}) => {
  const formatFileSize = (bytes) => {
    if (!bytes) return '0 B';
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return Math.round((bytes / Math.pow(1024, i)) * 100) / 100 + ' ' + sizes[i];
  };

  if (!attachments || attachments.length === 0) {
    return null;
  }

  return (
    <Box className="message-attachments">
      {attachments.map((attachment) => (
        <Chip
          key={attachment.id}
          size="small"
          className="attachment-chip"
          label={
            <Box sx={{display: 'flex', alignItems: 'center', width: '100%'}}>
              <Box className="attachment-info">
                <Typography variant="caption" className="attachment-filename">
                  {attachment.filename}
                </Typography>
                <Typography variant="caption" className="attachment-size">
                  {formatFileSize(attachment.size)}
                </Typography>
              </Box>
            </Box>
          }
          variant="outlined"
        />
      ))}
    </Box>
  );
};

MessageAttachments.propTypes = {
  attachments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      filename: PropTypes.string.isRequired,
      content_type: PropTypes.string.isRequired,
      size: PropTypes.number.isRequired,
    })
  ),
  conversationId: PropTypes.string,
  messageId: PropTypes.string,
};

export default MessageAttachments;
